module.exports = __webpack_public_path__ + "img/5.4c43f0c1.png";